import { CompilerComponent } from '@types';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export interface NumberInputProps {
  name: string;
  size: 'sm' | 'md' | 'lg';
  value: number;
  label: string;
  placeholder: string;
}

export interface NumberInputTriggers {
  onBlur: (value: string) => void;
}

export default {
  block,
  component,
  defaultProps,
  protocolFactory,
} as CompilerComponent<NumberInputProps>;
